import { all } from 'redux-saga/effects';

import address from './address';
import apps from './apps';
import auth from './auth';
import automations from './automations';
import billing from './billing';
import carrierAccounts from './carrier-accounts';
import carrierFormFields from './carrier-form-fields';
import carrierFormInput from './carrier-form-input';
import customs from './customs';
import featureTests from './feature-tests';
import filters from './filters';
import initializers from './initializers';
import labelsSettings from './labels-settings';
import lineItem from './line-item';
import manifests from './manifests';
import manualOrder from './manual-order';
import notifications from './notifications';
import orders from './orders';
import ordersBatch from './orders-batch';
import packages from './packages';
import pickups from './pickups';
import plans from './plans';
import promos from './promos';
import providers from './providers';
import ratesAtCheckoutSagas from './rates-at-checkout';
import routing from './routing';
import segment from './segment';
import shipments from './shipments';
import stores from './stores';
import token from './token';
import trackingSettings from './tracking-settings';
import transactions from './transactions';
import user from './user';
import userTracking from './user-tracking';
import versioning from './versioning';
import webhooks from './webhooks';

export default function* rootSaga() {
  yield all([
    ...initializers,
    ...user,
    ...address,
    ...auth,
    ...orders,
    ...shipments,
    ...ordersBatch,
    ...transactions,
    ...promos,
    ...pickups,
    ...routing,
    ...stores,
    ...providers,
    ...labelsSettings,
    ...notifications,
    ...filters,
    ...packages,
    ...featureTests,
    ...plans,
    ...automations,
    ...carrierAccounts,
    ...carrierFormFields,
    ...carrierFormInput,
    ...userTracking,
    ...lineItem,
    ...customs,
    ...manualOrder,
    ...billing,
    ...ratesAtCheckoutSagas,
    ...manifests,
    ...trackingSettings,
    ...token,
    ...webhooks,
    ...versioning,
    ...segment,
    ...apps,
  ]);
}
